<div class="container-fluid vh-100 text-center  overflow-auto">
  <main>
    <div class="text-center pb-5"><img src="../../../../assets/img/pointslogoFS.png" class="img-responsive logo" /></div>

    <div class="layout-content w-100 text-center" style="z-index:1000;">

      <router-outlet></router-outlet>
    </div>
    <div>
      Point S Polska, ul. Młynarska 7, 01-205 Warszawa<a href="mailto: point-s@point-s.pl" class="ml-2">point-s@point-s.pl</a>
    </div>
  </main>
</div>

